export const chain =
  (...fetchers) =>
  args => {
    if (args.preloadOnly) {
      fetchers.forEach(fetcher => fetcher(args));
      // This function shouldn't ever be executed but it makes the TypeScript types simpler by returning it as there is commonality in return types in this function
      return () => {};
    }
    return (dispatch, getState) =>
      fetchers.reduce(
        (prev, fetcher) => prev.then(() => fetcher(args)(dispatch, getState)),
        Promise.resolve(),
      );
  };
